import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../auth';
import {
  isH5RewardedEnabled,
  prepareH5RewardedAds,
  requestRewardedAd,
  type H5RewardedResult,
} from '../lib/h5Ads';

export function useAdRewarded() {
  const { user, loading: authLoading } = useAuth();
  const [loading, setLoading] = useState(false);

  const available = !authLoading && isH5RewardedEnabled() && !user?.is_premium;

  useEffect(() => {
    if (available) void prepareH5RewardedAds();
  }, [available]);

  const startRewardedAd = useCallback(async (): Promise<H5RewardedResult> => {
    if (!available || loading) return 'unavailable';
    setLoading(true);
    try {
      return await requestRewardedAd('sudoku-hint-reward');
    } finally {
      setLoading(false);
    }
  }, [available, loading]);

  return { loading, startRewardedAd, available };
}
